exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".notification .pagin-block{max-width:700px;float:right;margin:20px 10px}.notification .pagin-block .quantity{float:left;margin-right:5px}.notification .pagin-block .quantity p{color:#768589;margin-top:3px;font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/dashboard/notifications/notifications.scss
// module id = 998
// module chunks = 0